import {
  ISODate,
  useGetDataObjectDescriptionVersions,
} from '@atlas-frontend/sdk';
import { useCallback } from 'react';
import { path } from '../../paths';
import { withParams } from '../../paths/withParams';

export const useNavigateToDescriptionWithLatestActiveVersion = (
  dataObjectDescriptionId: number | null,
  valueDate: ISODate,
) => {
  const { refetch: fetchVersions } = useGetDataObjectDescriptionVersions(
    {
      id: dataObjectDescriptionId!,
      valueDate,
    },
    { enabled: false && !!dataObjectDescriptionId },
  );

  const navigateToDescriptionWithLatestVersion = useCallback(async () => {
    if (!dataObjectDescriptionId) return;

    let activeVersionId;
    try {
      const versions = await fetchVersions().then((res) => res.data);
      activeVersionId = versions?.find((v) => v.statusCode === 'ACTIVE')?.id;
    } catch (_) {
      activeVersionId = undefined;
    }

    if (!activeVersionId) return;

    const url = withParams(path.outputDataObjectView, { id: activeVersionId });

    window.open(url, '_blank');
  }, [dataObjectDescriptionId, fetchVersions]);

  return navigateToDescriptionWithLatestVersion;
};
